import { Component } from 'react';
import Menu from "../Menu";

class MenuEN extends Component {
  render() {

    return (
      
        <Menu 
          language="/en"
          switches={[
              { url: this.props.switchUrlNL, name: "NL" },
              { url: this.props.switchUrlFR, name: "FR" }
          ]}
          menus={[
              { url:"/en", name:"Home" },
              { url:"#", name:"Our team", 
                  children:[
                    { name:"Frank Coel", url: "/en/frank-coel"},
                    { name:"Anna Mamchenkova", url: "/en/anna-mamchenkova"},
                  ] 
              },
              { url:"#", name:"Our services", 
                  children:[
                    { name:"Companies in difficulty", url: "/en/companies-in-difficulty"},
                    { name:"Advice, defense and disputes", url: "/en/advice-defense-disputes"},
                  ] 
              },
              { url:"/en/publications", name:"Publications" },
              { url:"/en/press", name:"Press" },
              { url:"/en/contact", name:"Contact" },
          ]}
        />
        
    );
  }
}

export default MenuEN
